module.exports = __webpack_public_path__ + "img/area-comum-03.762edd0c.png";